import React, { useContext } from 'react';
import { LoaderContext } from '../../Services/Loader_Provider_Service/LoadingContext';

const Preloader = () => {
  const { loading } = useContext(LoaderContext);

  if (!loading) return null;

  return (
    <></>
    // <div id="preloader">
    //   <div className="loader">
    //     <div className="loader--dot"></div>
    //     <div className="loader--dot"></div>
    //     <div className="loader--dot"></div>
    //     <div className="loader--dot"></div>
    //     <div className="loader--dot"></div>
    //     <div className="loader--dot"></div>
    //     <div className="loader--text"></div>
    //   </div>
    // </div>
  );
};

export default Preloader;
